import type { ColorScheme } from "../App";

export namespace Colors {
    const colors = {
        "aliceblue": "#f0f8ff",
        "antiquewhite": "#faebd7",
        "aqua": "#00ffff",
        "aquamarine": "#7fffd4",
        "azure": "#f0ffff",
        "beige": "#f5f5dc",
        "bisque": "#ffe4c4",
        "black": "#000000",
        "blanchedalmond": "#ffebcd",
        "blue": "#0000ff",
        "blueviolet": "#8a2be2",
        "brown": "#a52a2a",
        "burlywood": "#deb887",
        "cadetblue": "#5f9ea0",
        "chartreuse": "#7fff00",
        "chocolate": "#d2691e",
        "coral": "#ff7f50",
        "cornflowerblue": "#6495ed",
        "cornsilk": "#fff8dc",
        "crimson": "#dc143c",
        "cyan": "#00ffff",
        "darkblue": "#00008b",
        "darkcyan": "#008b8b",
        "darkgoldenrod": "#b8860b",
        "darkgray": "#a9a9a9",
        "darkgreen": "#006400",
        "darkkhaki": "#bdb76b",
        "darkmagenta": "#8b008b",
        "darkolivegreen": "#556b2f",
        "darkorange": "#ff8c00",
        "darkorchid": "#9932cc",
        "darkred": "#8b0000", "darksalmon": "#e9967a",
        "darkseagreen": "#8fbc8f",
        "darkslateblue": "#483d8b",
        "darkslategray": "#2f4f4f",
        "darkturquoise": "#00ced1",
        "darkviolet": "#9400d3",
        "deeppink": "#ff1493",
        "deepskyblue": "#00bfff",
        "dimgray": "#696969",
        "dodgerblue": "#1e90ff",
        "firebrick": "#b22222",
        "floralwhite": "#fffaf0",
        "forestgreen": "#228b22",
        "fuchsia": "#ff00ff",
        "gainsboro": "#dcdcdc",
        "ghostwhite": "#f8f8ff",
        "gold": "#ffd700",
        "goldenrod": "#daa520",
        "gray": "#808080",
        "green": "#008000",
        "greenyellow": "#adff2f",
        "honeydew": "#f0fff0",
        "hotpink": "#ff69b4",
        "indianred ": "#cd5c5c",
        "indigo": "#4b0082",
        "ivory": "#fffff0",
        "khaki": "#f0e68c",
        "lavender": "#e6e6fa",
        "lavenderblush": "#fff0f5",
        "lawngreen": "#7cfc00",
        "lemonchiffon": "#fffacd",
        "lightblue": "#add8e6",
        "lightcoral": "#f08080",
        "lightcyan": "#e0ffff",
        "lightgoldenrodyellow": "#fafad2",
        "lightgrey": "#d3d3d3",
        "lightgreen": "#90ee90",
        "lightpink": "#ffb6c1",
        "lightsalmon": "#ffa07a",
        "lightseagreen": "#20b2aa",
        "lightskyblue": "#87cefa",
        "lightslategray": "#778899",
        "lightsteelblue": "#b0c4de",
        "lightyellow": "#ffffe0",
        "lime": "#00ff00",
        "limegreen": "#32cd32",
        "linen": "#faf0e6",
        "magenta": "#ff00ff",
        "maroon": "#800000",
        "mediumaquamarine": "#66cdaa",
        "mediumblue": "#0000cd",
        "mediumorchid": "#ba55d3",
        "mediumpurple": "#9370d8",
        "mediumseagreen": "#3cb371",
        "mediumslateblue": "#7b68ee",
        "mediumspringgreen": "#00fa9a",
        "mediumturquoise": "#48d1cc",
        "mediumvioletred": "#c71585",
        "midnightblue": "#191970",
        "mintcream": "#f5fffa",
        "mistyrose": "#ffe4e1",
        "moccasin": "#ffe4b5",
        "navajowhite": "#ffdead",
        "navy": "#000080",
        "oldlace": "#fdf5e6",
        "olive": "#808000",
        "olivedrab": "#6b8e23",
        "orange": "#ffa500",
        "orangered": "#ff4500",
        "orchid": "#da70d6",
        "palegoldenrod": "#eee8aa",
        "palegreen": "#98fb98",
        "paleturquoise": "#afeeee",
        "palevioletred": "#d87093",
        "papayawhip": "#ffefd5",
        "peachpuff": "#ffdab9",
        "peru": "#cd853f",
        "pink": "#ffc0cb",
        "plum": "#dda0dd",
        "powderblue": "#b0e0e6",
        "purple": "#800080",
        "rebeccapurple": "#663399",
        "red": "#ff0000",
        "rosybrown": "#bc8f8f",
        "royalblue": "#4169e1",
        "saddlebrown": "#8b4513",
        "salmon": "#fa8072",
        "sandybrown": "#f4a460",
        "seagreen": "#2e8b57",
        "seashell": "#fff5ee",
        "sienna": "#a0522d",
        "silver": "#c0c0c0",
        "skyblue": "#87ceeb",
        "slateblue": "#6a5acd",
        "slategray": "#708090",
        "snow": "#fffafa",
        "springgreen": "#00ff7f",
        "steelblue": "#4682b4",
        "tan": "#d2b48c",
        "teal": "#008080",
        "thistle": "#d8bfd8",
        "tomato": "#ff6347",
        "turquoise": "#40e0d0",
        "violet": "#ee82ee",
        "wheat": "#f5deb3",
        "white": "#ffffff",
        "whitesmoke": "#f5f5f5",
        "yellow": "#ffff00",
        "yellowgreen": "#9acd32"
    };

    export function of(color: string) {
        return colors[color.toLowerCase()];
    }
}

export function brightenHex(hex: string, percent: number) {
    // Strip the # if present
    hex = hex.replace(/^#/, '');

    // Convert to RGB
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Increase each channel and clamp to 255
    r = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
    g = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
    b = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));

    // Convert back to Hex
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

// const monthColors = [ 
//   Color.cyan.darker.darker.darker,
//   Color.cyan.darker.darker,
//   Color.yellow.darker.darker.darker,
//   Color.red.darker.darker.darker,
//   Color.red.darker.darker,
//   Color.yellow.darker.darker.darker,
//   Color.white.darker.darker.darker,
//   Color.white.darker.darker,
//   Color.yellow.darker.darker.darker,
//   Color.magenta.darker.darker.darker,
//   Color.magenta.darker.darker,
//   Color.yellow.darker.darker.darker
// ]

// val planetColors = Array(
//   Color.magenta.darker,
//   Color.white,
//   Color.blue,
//   Color.red,
//   Color.cyan,
//   Color.yellow,
//   Color.orange.darker.darker,
//   Color.green.darker.darker,
//   Color.gray.darker.darker,
//   Color.blue
// )

//        chartColors = new Color[] {
//            Color.BLUE,
//                    Color.YELLOW,
//                    Color.CYAN,
//                    Color.MAGENTA,
//                    Color.PINK,
//                    Color.ORANGE,
//                    Color.WHITE,
//                    Color.RED.darker,
//                    Color.GREEN.darker,
//        };
export const chartColors = [
    '#FFFFFF', // .darker // white Venus
    "#FFFF00", // yellow Sun
    "#FF00FF", // Magenta Pluto
    "#00FF00", // Green Earth
    "#0000FF", // Blue Mercury
    "#FF0000", // Red Mars
    "#00FFFF", // Cyan, Jupiter
    "#FFC0CB", // Pink, Uranus
    "#FFFF00", // .darker, // yellow Saturn
    "#D2D3D3", // lightgray Neptune
    "#A9A9A9"  // darkgray MOON
]

export const positiveColor = (colorScheme: ColorScheme) => {
    return colorScheme === 'light'
        ? '#FF0000B4'
        : '#FF0000'
}

export const negativeColor = (colorScheme: ColorScheme) => {
    return colorScheme === 'light'
        ? '#00AA00B4'
        : '#00AA00'
}

export const styleOfAnnot = (className: string, colorScheme: ColorScheme, isText?: boolean) => {
    if (isText) {
        switch (className) {
            case 'annot-mouse':
                return {
                    fill: colorScheme === 'light' ? '#ffffff' : '#000000',
                    fontSize: '12px'
                }

            case 'annot-refer':
                return {
                    fill: colorScheme === 'light' ? '#ffffff' : '#000000',
                    fontSize: '12px'
                }

            case 'annot-positive':
                return {
                    fill: colorScheme === 'light' ? '#ffffff' : '#000000',
                    fontSize: '12px'
                }

            case 'annot-negative':
                return {
                    fill: colorScheme === 'light' ? '#ffffff' : '#ffffff',
                    fontSize: '12px'
                }
        }

    } else {
        switch (className) {
            case 'annot-mouse':
                return {
                    stroke: colorScheme === 'light' ? '#009000' : '#00F000',
                    fill: colorScheme === 'light' ? '#009000' : '#00F000',
                    strokeWidth: '0.7px',
                }

            case 'annot-refer':
                return {
                    stroke: colorScheme === 'light' ? '#00A0A0' : '#00F0F0',
                    fill: colorScheme === 'light' ? '#00A0A0' : '#00F0F0',
                    strokeWidth: '0.7px'
                }

            case 'annot-positive':
                return {
                    stroke: colorScheme === 'light' ? '#FF0000B4' : '#FF0000',
                    fill: colorScheme === 'light' ? '#FF0000B4' : '#FF0000',
                    strokeWidth: '0.7px'
                }

            case 'annot-negative':
                return {
                    stroke: colorScheme === 'light' ? '#00AA00B4' : '#00AA00',
                    fill: colorScheme === 'light' ? '#00AA00B4' : '#00AA00',
                    strokeWidth: '0.7px'
                }

        }
    }
}

export function styleOfLabel(className: string, colorScheme: ColorScheme) {
    switch (className) {
        case 'label-title':
            return {
                fill: colorScheme === 'light' ? '#FF0000' : '#FF0000',
                fontSize: '12px'
            }

        case 'label-mouse':
            return {
                fill: colorScheme === 'light' ? '#009000' : '#00F000',
                fontSize: '12px'
            }

        case 'label-refer':
            return {
                fill: colorScheme === 'light' ? '#00A0A0' : '#00F0F0',
                fontSize: '12px'
            }

    }
}